import { z } from 'zod';
const toolSchemaBuilder = (schema) => ({
    /**
     * Extends the basic schema with the given fields
     */
    extend: (fields) => toolSchemaBuilder(schema.extend(fields)),
    /**
     * Adds a page number to the schema, this is useful for tools that rely on pagination
     */
    withPagination: () => toolSchemaBuilder(schema.extend({
        // We need to coerce because LLMs were passing strings instead of numbers quite often (via MCP)
        page: z.coerce
            .number()
            .positive()
            .nullable()
            .describe('Paginate results starting at 1. Pass a positive number (e.g. 1), never NaN or the string "null".'),
    })),
    /**
     * Builds the schema
     */
    build: () => schema,
    /**
     * Returns the zod schema so far
     */
    schema,
});
function createToolSchema() {
    return toolSchemaBuilder(z.object({}));
}
export { createToolSchema };
//# sourceMappingURL=toolSchemaBuilder.js.map